import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["getOptionValue", "value", "defaultValues", "options", "styleOverrides", "sort", "id", "useSelectValues", "shouldSortOptions", "noOptionsMessage"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * This wrapper is for Select components WITHOUT the async behaviour. For Example Select and Creatable.
 * This particular component has a single responsibility
 * 1. Convert selected value id's into an option object which is then passed to select such that it is consumable by react-select.
 * 2. Extract the value from the selected option and adds it as a parameter to onChange.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';
import _noop from 'lodash/noop';
import _property from 'lodash/property';

// Constants
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import { DEFAULT_SELECT_SORT_ORDER } from '@tekion/tekion-base/constants/sortOrder';

// Helpers
import { getSanitizedOptions } from '@tekion/tekion-base/utils/selectSort';
import { getSelectValues, defaultFilterOption } from './withBaseSelect.helpers';
import { getOnChangeValue, getLoadingMessage, getNoOptionsMessage } from '../../helpers/advancedSelect.general';

// Styles
import { getSelectStyles } from '../../styles/AdvancedSelect.styles';
import MenuPortal from '../../components/MenuPortal';
var REACT_SELECT_CUSTOM_COMPONENTS = {
  MenuPortal: MenuPortal
};
var withBaseSelect = function withBaseSelect(WrappedComponent) {
  var WithBaseSelect = /*#__PURE__*/function (_Component) {
    _inherits(WithBaseSelect, _Component);
    var _super = _createSuper(WithBaseSelect);
    function WithBaseSelect() {
      var _this;
      _classCallCheck(this, WithBaseSelect);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "getSelectStyles", defaultMemoize(getSelectStyles));
      _defineProperty(_assertThisInitialized(_this), "getSanitizedOptions", defaultMemoize(getSanitizedOptions));
      /**
       * Captures the onChange of select and adds the value directly in the select onChange response.
       */
      _defineProperty(_assertThisInitialized(_this), "handleChange", function (option, eventDetails) {
        var _this$props = _this.props,
          getOptionValue = _this$props.getOptionValue,
          onChange = _this$props.onChange;
        // The below value is always an array to make it consistent with the multi select use case.
        var value = getOnChangeValue(getOptionValue, option);
        onChange({
          value: value,
          option: option,
          eventDetails: eventDetails
        });
      });
      return _this;
    }
    _createClass(WithBaseSelect, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
          getOptionValue = _this$props2.getOptionValue,
          value = _this$props2.value,
          defaultValues = _this$props2.defaultValues,
          options = _this$props2.options,
          styleOverrides = _this$props2.styleOverrides,
          sort = _this$props2.sort,
          id = _this$props2.id,
          useSelectValues = _this$props2.useSelectValues,
          shouldSortOptions = _this$props2.shouldSortOptions,
          noOptionsMessage = _this$props2.noOptionsMessage,
          restProps = _objectWithoutProperties(_this$props2, _excluded);
        var updatedOptions = this.getSanitizedOptions(options, shouldSortOptions, sort);
        // Convert the list of value string to an option.
        var selectValues = getSelectValues(getOptionValue, updatedOptions, value);
        // Convert the list of default value string to an option.
        var selectDefaultValues = getSelectValues(getOptionValue, updatedOptions, defaultValues);
        var styles = this.getSelectStyles(styleOverrides);
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, restProps, {
          defaultValue: selectDefaultValues,
          getOptionValue: getOptionValue,
          loadingMessage: getLoadingMessage,
          noOptionsMessage: noOptionsMessage,
          onChange: this.handleChange,
          options: updatedOptions,
          styles: styles,
          value: useSelectValues ? selectValues : value,
          id: id,
          inputId: id
        }));
      }
    }]);
    return WithBaseSelect;
  }(Component);
  WithBaseSelect.propTypes = {
    defaultValues: PropTypes.array,
    getOptionValue: PropTypes.func,
    // eslint-disable-line react/require-default-props
    onChange: PropTypes.func,
    options: PropTypes.array,
    value: PropTypes.array,
    components: EMPTY_ARRAY,
    menuPortalTarget: PropTypes.node,
    menuPosition: PropTypes.string,
    menuPlacement: PropTypes.string,
    filterOption: PropTypes.func,
    useSelectValues: PropTypes.bool,
    sort: PropTypes.arrayOf(PropTypes.shape({
      order: PropTypes.string,
      field: PropTypes.string
    })),
    shouldSortOptions: PropTypes.bool,
    noOptionsMessage: PropTypes.func
  };
  WithBaseSelect.defaultProps = {
    defaultValues: EMPTY_ARRAY,
    onChange: _noop,
    options: EMPTY_ARRAY,
    value: EMPTY_ARRAY,
    useSelectValues: true,
    getOptionValue: _property('value'),
    components: REACT_SELECT_CUSTOM_COMPONENTS,
    menuPortalTarget: document.body,
    menuPosition: 'fixed',
    menuPlacement: 'auto',
    filterOption: defaultFilterOption,
    sort: DEFAULT_SELECT_SORT_ORDER,
    shouldSortOptions: false,
    noOptionsMessage: getNoOptionsMessage
  };
  return WithBaseSelect;
};
export default withBaseSelect;